query GetWindowDecorations {
    WindowDecorations {
        docs {
            id
            name
            subtitle
            image {
                url
            }
            colors {
                id
                hexColor
                name
                price
                type
                image {
                    url
                }
            }
        }
    }
}
